/* eslint-disable arrow-body-style */
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    install(Vue, loadingOptions) {
        Vue.use(Loading, loadingOptions);
        Vue.prototype.$delayedLoading = {
            show(opts) {
                const settings = { ...loadingOptions, ...opts };
                let loader = { hide: () => {} };
                const timeout = setTimeout(() => {
                    loader = Vue.prototype.$loading.show(settings);
                }, settings.delay);
                return {
                    hide: () => {
                        clearTimeout(timeout);
                        loader.hide();
                    },
                };
            },
        };

        /**
         * wrap a function with a loader
         * @param {Object} fn The function to wrap with a delayed loader
         */
        Vue.prototype.$loader = async (fn) => {
            let loading;
            try {
                loading = Vue.prototype.$delayedLoading.show();
                const result = await fn();
                loading.hide();
                return result;
            } catch (error) {
                loading.hide();
                return error;
            }
        };
    },
};
